// User reducer types

export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const BLOCK_USER_FAILURE = 'BLOCK_USER_FAILURE';
export const BLOCK_USER_SUCCESS = 'BLOCK_USER_SUCCESS';
export const UNBLOCK_USER_FAILURE = 'UNBLOCK_USER_FAILURE';
export const UNBLOCK_USER_SUCCESS = 'UNBLOCK_USER_SUCCESS';
export const SUBMIT_DATA = 'SUBMIT_DATA';
export const REQUEST_DATA = 'REQUEST_DATA';
export const USER_STATUS_UPDATE_SUCCESS= 'USER_STATUS_UPDATE_SUCCESS';
export const USER_STATUS_UPDATE_FAILULE= 'USER_STATUS_UPDATE_FAILULE';
